<template>
    <div class="c-tooltip">
        <div class="c-tooltip__tip" v-if="show">
            {{ title }}
        </div>
        <div @click="show = !show">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['title'],
        data(){
            return {
                show: false
            }
        }
    }
</script>